// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-form-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  justify-content: space-between;\n  height: 100%; }\n\n@media screen and (max-width: 900px) {\n  .contact-form-container {\n    display: flex;\n    flex-direction: column; } }\n", ""]);
// Exports
module.exports = exports;
